import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBase } from './form-base';
import { FormGroupControlService } from '../../services/formgroup-control.service';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'rm-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.css']
})
export class DynamicFormComponent {

    @Input() fields: FormBase<any>[] = [];

    @Input() values: any[] = [];

    @Input('isReadOnly')
    isReadOnly: boolean;

    @Output()
    statusChange = new EventEmitter<string>();

    subscriptions: any[] = [];

    form: FormGroup;
    payload = '';

    constructor(public fcs: FormGroupControlService) { }

    ngOnInit() {
        this.form = this.fcs.toFormGroup(this.fields, this.values);
        this.subscriptions.push(this.form.statusChanges.subscribe(
            (status)=> {
                this.statusChange.emit(status);
            }
        ));
    }
    
    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    onSubmit() {
        this.payload = JSON.stringify(this.form.value);
    }
}
